/**
 * Storage constants for CloudStorage migration
 */

// CloudStorage у Telegram общий на пользователя и синхронизируется между всеми его
// устройствами, поэтому слоты аккаунтов и сессии перетекали с девайса на девайс:
// Mini App открывал ранее залогиненный аккаунт вместо запрошенного.
// Слоты должны быть привязаны к конкретному webview, то есть к localStorage.
export const IS_CLOUD_STORAGE_ENABLED = false;

// CloudStorage key prefix to avoid conflicts
// Note: CloudStorage doesn't accept colons, using underscores instead
export const KEY_PREFIX = 'tt_v1_';

// Maximum chunk size (leaving margin below 4096 byte limit)
export const CHUNK_SIZE = 3800;

// Migration version
export const CURRENT_MIGRATION_VERSION = 1;

// Storage key patterns
export const STORAGE_KEYS = {
  // Account data keys
  accountMeta: (slot: number) => `${KEY_PREFIX}account_${slot}_meta`,
  accountAuth: (slot: number) => `${KEY_PREFIX}account_${slot}_auth`,

  // Passcode keys
  passcodeSession: `${KEY_PREFIX}passcode_session`,
  passcodeGlobal: `${KEY_PREFIX}passcode_global`,

  // Service keys
  migrationStatus: `${KEY_PREFIX}migration_status`,
  syncVersion: `${KEY_PREFIX}sync_version`,

  // Chunked data patterns
  chunkMeta: (keyPrefix: string) => `${keyPrefix}_meta`,
  chunk: (keyPrefix: string, index: number) => `${keyPrefix}_chunk_${index}`,
} as const;

// Retry configuration for network operations
export const RETRY_CONFIG = {
  maxAttempts: 3,
  baseDelay: 1000, // ms
  maxDelay: 5000, // ms
} as const;

// Migration cleanup delay (7 days in ms)
export const MIGRATION_CLEANUP_DELAY = 7 * 24 * 60 * 60 * 1000;

// Sync check interval (5 seconds)
export const SYNC_CHECK_INTERVAL = 5000;
